/* eslint-disable prettier/prettier */
import { Grid } from '@mui/material';
import { RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';
import React, { forwardRef } from 'react';

//Iconos
import InstructionIcon from '../../../../../assets/svg/InstructionIcon';

import { Stop, StopType } from '../../../../../domain/stop/Stop';
import { Text } from '../../../../../react-components/Text';

// Ferlo much more versatil i generic
export type BarStyle = `void` | `highlighted` | `unhighlighted`;
export type TagStyle = `highlighted` | `unhighlighted` | `start` | `end`;

const TagTextSimplified = ({
  children,
  stopType,
  styleTag,
}: React.PropsWithChildren<{
  stopType?: StopType;
  styleTag?: React.CSSProperties;
}>) => {
  return (
    <Text
      style={{
        background: RoutalPalette.primary20n,
        color: RoutalPalette.primary40,
        border: `2px solid ${RoutalPalette.primary40}`,
        borderRadius: stopType === `pickup` ? `10px` : `50%`,
        display: `flex`,
        justifyContent: `center`,
        alignItems: `center`,
        width: `30px`,
        height: `30px`,
        maxHeight: `30px`,
        fontSize: `16px`,
        ...styleTag,
      }}
    >
      {children}
    </Text>
  );
};

const LabelStop = ({ labelStyles, children }: React.PropsWithChildren<{ labelStyles: React.CSSProperties }>) => {
  if (children)
    return (
      <Text
        style={{
          ...labelStyles,
          overflow: `hidden`,
          textOverflow: `ellipsis`,
          margin: `3px 0px`,
          lineHeight: `1.5em`,
          maxHeight: `3em`,
          display: `-webkit-box`,
          WebkitLineClamp: 2,
          WebkitBoxOrient: `vertical`,
        }}
      >
        {children}
      </Text>
    );
  else
    return (
      <Text
        intlId="stop.label_stop.empty"
        style={{
          ...labelStyles,
          overflow: `hidden`,
          textOverflow: `ellipsis`,
          margin: `8px 0px 3px 0px`,
          lineHeight: `1.5em`,
          maxHeight: `3em`,
          display: `-webkit-box`,
          WebkitLineClamp: 2,
          WebkitBoxOrient: `vertical`,
          color: RoutalPalette.grey7,
          fontStyle: `italic`,
        }}
      />
    );
};

type ReorderStopPillProps = {
  stop: Stop;
  stopType?: StopType;
  showCustomerField?: boolean;
  showInProgress?: boolean;

  order: number;
  styleTag: React.CSSProperties;
  tagStyle: TagStyle;
  containerStyles?: React.CSSProperties;

  handleOnClick: (stop_id: string) => void;
};

export const ReorderStopPill = forwardRef<HTMLDivElement, ReorderStopPillProps>(
  (
    {
      stop,
      stopType,
      showCustomerField = false,
      showInProgress = false,
      order,
      containerStyles,
      styleTag,
      handleOnClick,
    },
    ref
  ) => {
    return (
      // Main container
      <Grid
        ref={ref}
        style={{
          display: `flex`,
          flexDirection: `row`,
          width: `100%`,
          zIndex: `1001`,
          position: `relative`,
          padding: `8px 10px`,
          ...containerStyles,
        }}
        onClick={() => {
          return stop.id ? handleOnClick(stop.id) : null;
        }}
      >
        {/* Position and 'tracking position' container */}
        <Grid style={{ display: `flex`, flexDirection: `column`, alignItems: `center`, justifyContent: `center` }}>
          <div style={{ position: `relative`, minHeight: `34px`, opacity: 1 }}>
            {showCustomerField && stop.customer_text_field && (
              <div
                style={{
                  backgroundColor: showInProgress ? RoutalPalette.success.medium : RoutalPalette.warning.medium,
                  borderRadius: `50%`,
                  height: `18px`,
                  width: `18px`,
                  top: `-3px`,
                  right: `-5px`,
                  position: `absolute`,
                  display: `flex`,
                  justifyContent: `center`,
                  alignItems: `center`,
                }}
              >
                <InstructionIcon
                  alt="Customer fields"
                  style={{ width: `12px`, height: `12px`, color: RoutalPalette.white }}
                />
              </div>
            )}
            <TagTextSimplified stopType={stopType} styleTag={styleTag}>
              {order}
            </TagTextSimplified>
          </div>
        </Grid>

        {/* Stop information container */}
        <Grid style={{ display: `flex`, flexDirection: `column`, width: `100%`, marginLeft: `15px`, opacity: 1 }}>
          <VSpacer small />
          <LabelStop
            labelStyles={{
              color: RoutalPalette.text,
              fontSize: `16px`,
              fontWeight: `500`,
              height: `fit-content`,
            }}
          >
            {stop.location?.label}
          </LabelStop>
          {stop.label ? (
            <LabelStop labelStyles={{ color: RoutalPalette.secondary00, fontSize: `13px`, height: `fit-content` }}>
              {stop.label}
            </LabelStop>
          ) : null}
          <VSpacer small />
        </Grid>
      </Grid>
    );
  }
);
